import React from "react"
import { Modal, ModalBody, Button } from "reactstrap"

const ConfirmDialog = ({ open, title, body, confirmLabel = "Confirm", danger = true, onConfirm, onCancel }) => (
  <Modal isOpen={open} toggle={onCancel} centered>
    <ModalBody>
      <div className="d-flex gap-3 align-items-start">
        <div
          className={`rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 ${
            danger ? "bg-danger bg-opacity-10" : "bg-primary bg-opacity-10"
          }`}
          style={{ width: 44, height: 44 }}
        >
          <i
            className={`mdi ${danger ? "mdi-alert-circle-outline text-danger" : "mdi-information-outline text-primary"}`}
            style={{ fontSize: "22px" }}
          />
        </div>
        <div>
          <h5 className="mb-2">{title}</h5>
          <p className="text-muted mb-0">{body}</p>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button color="light" onClick={onCancel}>
          Cancel
        </Button>
        <Button color={danger ? "danger" : "primary"} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </ModalBody>
  </Modal>
)

export default ConfirmDialog
